export default "__VITE_ASSET__1AtY81$Q__"